export const RQ_GET_HOSPITAL_RCPA_REPORTS = {
  url:'visitrcpa/hospital_rcpa_report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_HOSPITAL_RCPA_DETAIL_REPORTS = {
  url:'visitrcpa/hospital_rcpa_detail_report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_HOSPITAL_EMROK_MONTHLY_SALES_REPORTS = {
  url:'hospitalmonthlysales/get-hospital-monthly-report/<%= locationId %>',
  method:'GET',
  auth:true,
};
